import { Spin } from 'antd';
import React, { Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import BorrowerDashboard from './dashboard';
import Project from './project';
import Wallet from './wallet';
import Member from './member';
import Validation from './validation';
import DocumentsRoute from './documents';
import withAdminLayout from '../../layout/withAdminLayout';
import BorrowerStripeConnect from '../../components/stripe/BorrowerStripeConnect';
// import BorrowerDepositPage from '../../components/stripe/BorrowerDeposit';
import StripeReauthPage from '../../components/stripe/StripeReauthPage';
import StripeSuccessPage from '../../components/stripe/StripeSuccessPage';
import PaymentSuccessPage from '../../components/pesapal/PaymentSuccessPage';
import ManualBorrowerDepositPage from '../../components/stripe/manual-Deposit';

const Borrower = React.memo(() => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route index path="/*" element={<BorrowerDashboard />} />
        <Route path="pages/*" element={<BorrowerDashboard />} />
        <Route path="project/*" element={<Project />} />
        <Route path="members/*" element={<Member />} />
        <Route path="validation/*" element={<Validation />} />
        <Route path="wallet/*" element={<Wallet />} />
        <Route path="documents/*" element={<DocumentsRoute />} />
        <Route path="connect" element={<BorrowerStripeConnect />} />
        <Route path="reauth" element={<StripeReauthPage />} />
        <Route path="success" element={<StripeSuccessPage />} />
        <Route path="payment/success" element={<PaymentSuccessPage />} />
        <Route path="deposit" element={<ManualBorrowerDepositPage />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Borrower);
